export const PERMISSIONS = {
  // USER
  USER_LIST: "USER_LIST",
  USER_CREATE: "USER_CREATE",
  USER_VIEW: "USER_VIEW",
  USER_UPDATE: "USER_UPDATE",
  USER_DELETE: "USER_DELETE",

  // ROLE
  ROLE_LIST: "ROLE_LIST",
  ROLE_CREATE: "ROLE_CREATE",
  ROLE_VIEW: "ROLE_VIEW",
  ROLE_UPDATE: "ROLE_UPDATE",
  ROLE_DELETE: "ROLE_DELETE",

  // INVESTOR
  INVESTOR_LIST: "INVESTOR_LIST",
  INVESTOR_CREATE: "INVESTOR_CREATE",
  INVESTOR_VIEW: "INVESTOR_VIEW",
  INVESTOR_UPDATE: "INVESTOR_UPDATE",
  INVESTOR_DELETE: "INVESTOR_DELETE",

  // WEALTH_PARTNER
  WEALTH_PARTNER_LIST: "WEALTH_PARTNER_LIST",
  WEALTH_PARTNER_CREATE: "WEALTH_PARTNER_CREATE",
  WEALTH_PARTNER_VIEW: "WEALTH_PARTNER_VIEW",
  WEALTH_PARTNER_UPDATE: "WEALTH_PARTNER_UPDATE",
  WEALTH_PARTNER_DELETE: "WEALTH_PARTNER_DELETE",

  // ICD
  ICD_LIST: "ICD_LIST",
  ICD_CREATE: "ICD_CREATE",
  ICD_VIEW: "ICD_VIEW",
  ICD_UPDATE: "ICD_UPDATE",
  ICD_DELETE: "ICD_DELETE",

  // BOND
  BOND_LIST: "BOND_LIST",
  BOND_CREATE: "BOND_CREATE",
  BOND_VIEW: "BOND_VIEW",
  BOND_UPDATE: "BOND_UPDATE",
  BOND_DELETE: "BOND_DELETE",

  // BOND
  BOND_REQUEST_LIST: "BOND_REQUEST_LIST",
  BOND_REQUEST_CREATE: "BOND_REQUEST_CREATE",
  BOND_REQUEST_VIEW: "BOND_REQUEST_VIEW",
  BOND_REQUEST_UPDATE: "BOND_REQUEST_UPDATE",
  BOND_REQUEST_DELETE: "BOND_REQUEST_DELETE",

  // REIT
  REIT_LIST: "REIT_LIST",
  REIT_CREATE: "REIT_CREATE",
  REIT_VIEW: "REIT_VIEW",
  REIT_UPDATE: "REIT_UPDATE",
  REIT_DELETE: "REIT_DELETE",

  // PLATFORM_MANAGER
  PLATFORM_MANAGER_LIST: "PLATFORM_MANAGER_LIST",
  PLATFORM_MANAGER_CREATE: "PLATFORM_MANAGER_CREATE",
  PLATFORM_MANAGER_VIEW: "PLATFORM_MANAGER_VIEW",
  PLATFORM_MANAGER_UPDATE: "PLATFORM_MANAGER_UPDATE",
  PLATFORM_MANAGER_DELETE: "PLATFORM_MANAGER_DELETE",

  // PERMISSION
  PERMISSION_LIST: "PERMISSION_LIST",
  PERMISSION_CREATE: "PERMISSION_CREATE",
  PERMISSION_VIEW: "PERMISSION_VIEW",
  PERMISSION_UPDATE: "PERMISSION_UPDATE",
  PERMISSION_DELETE: "PERMISSION_DELETE",

  // REPORT
  REPORT_LIST: "REPORT_LIST",
  REPORT_CREATE: "REPORT_CREATE",
  REPORT_VIEW: "REPORT_VIEW",
  REPORT_UPDATE: "REPORT_UPDATE",
  REPORT_DELETE: "REPORT_DELETE",

  // BLOG
  BLOG_LIST: "BLOG_LIST",
  BLOG_VIEW: "BLOG_VIEW",
  BLOG_CREATE: "BLOG_CREATE",
  BLOG_UPDATE: "BLOG_UPDATE",
  BLOG_DELETE: "BLOG_DELETE",

  // FAQ
  FAQ_LIST: "FAQ_LIST",
  FAQ_VIEW: "FAQ_VIEW",
  FAQ_CREATE: "FAQ_CREATE",
  FAQ_UPDATE: "FAQ_UPDATE",
  FAQ_DELETE: "FAQ_DELETE",

  //video
  VIDEO_LIST: "VIDEO_LIST",
  VIDEO_VIEW: "VIDEO_VIEW",
  VIDEO_CREATE: "VIDEO_CREATE",
  VIDEO_UPDATE: "VIDEO_UPDATE",
  VIDEO_DELETE: "VIDEO_DELETE",

  //about us
  ABOUT_US_LIST: "ABOUT_US_LIST",
  ABOUT_US_VIEW: "ABOUT_US_VIEW",
  ABOUT_US_CREATE: "ABOUT_US_CREATE",
  ABOUT_US_UPDATE: "ABOUT_US_UPDATE",
  ABOUT_US_DELETE: "ABOUT_US_DELETE",

  //about icds
  ABOUT_ICD_LIST: "ABOUT_ICD_LIST",
  ABOUT_ICD_VIEW: "ABOUT_ICD_VIEW",
  ABOUT_ICD_CREATE: "ABOUT_ICD_CREATE",
  ABOUT_ICD_UPDATE: "ABOUT_ICD_UPDATE",
  ABOUT_ICD_DELETE: "ABOUT_ICD_DELETE",

  // founder message
  FOUNDER_MESSAGE_LIST: "FOUNDER_MESSAGE_LIST",
  FOUNDER_MESSAGE_VIEW: "FOUNDER_MESSAGE_VIEW",
  FOUNDER_MESSAGE_CREATE: "FOUNDER_MESSAGE_CREATE",
  FOUNDER_MESSAGE_UPDATE: "FOUNDER_MESSAGE_UPDATE",
  FOUNDER_MESSAGE_DELETE: "FOUNDER_MESSAGE_DELETE",

  // documents
  DOC_LIST: "DOC_LIST",
  DOC_VIEW: "DOC_VIEW",
  DOC_CREATE: "DOC_CREATE",
  DOC_UPDATE: "DOC_UPDATE",
  DOC_DELETE: "DOC_DELETE",

  // Help
  HELP_LIST: "HELP_LIST",
  HELP_VIEW: "HELP_VIEW",
  HELP_CREATE: "HELP_CREATE",
  HELP_UPDATE: "HELP_UPDATE",
  HELP_DELETE: "HELP_DELETE",
}
